import { render, staticRenderFns } from "./TournamentMember.vue?vue&type=template&id=69355348"
import script from "./TournamentMember.vue?vue&type=script&lang=js"
export * from "./TournamentMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports